import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BaseFormConfig, SignUpConfigResponse, SubTypes } from '../../../../Auth/logic/Auth.types';

const initialState: { isOpen: boolean; hasSelected?: boolean } = {
  isOpen: false,
  hasSelected: false,
};

export const createAccountReducer = createSlice({
  name: 'createAccount',
  initialState,
  reducers: {
    setOpen(state, action: PayloadAction<{ isOpen: boolean }>) {
      state.isOpen = action?.payload?.isOpen;
    },
    setHasSelected(state, action: PayloadAction<{ hasSelected: boolean }>) {
      state.hasSelected = action?.payload?.hasSelected;
    },
  },
});
export const { setOpen, setHasSelected } = createAccountReducer.actions;

export default createAccountReducer.reducer;
